<!-- @format -->

<template>
	<border-box>
		<div class="noticeList">
			<div class="title">
				公告栏
				<div v-if="!isWorkbenchedit" class="more" @click="goTOWork">
					更多
					<el-icon style="font-size: 14px">
						<ArrowRightBold />
					</el-icon>
				</div>
			</div>
			<div class="list">
				<template v-if="tableData.length > 0">
					<el-row v-for="item in tableData" :key="item.id" class="detail-info" :gutter="20" @click="tableClick(item)">
						<el-col :span="12" class="left">
							<el-tooltip class="box-item" effect="dark" :content="item.noticeTitle">
								{{ item.noticeTitle }}
							</el-tooltip>
						</el-col>
						<el-col :span="12" class="right">
							{{ item.deployTime }}
						</el-col>
					</el-row>
				</template>
				<template v-else>
					<div class="nodata">暂无数据</div>
				</template>
			</div>
			<!-- <notice-details ref="detailsRef" :content-info="contentInfo" /> -->
		</div>
		<div v-show="isWorkbenchedit" class="delEdit">
			<el-icon @click="delEdit"><icon-ant-design:delete-outlined /></el-icon>
		</div>
	</border-box>
</template>

<script setup name="noticeList">
	import { ref } from 'vue';
	import { openWindow } from '@power/utils';
	import borderBox from './border-box.vue';
	import { getnoticeall } from '@/api/powercess/workbench';
	// import noticeDetails from '@/views/system/announcement/noticeDetails';
	const { proxy } = getCurrentInstance();
	const defaultSort = ref([{ field: 'deploy_time', order: 'DESC' }]);
	const emit = defineEmits(['deletePanelItemEvent']);
	const props = defineProps({
		isHeight: {
			type: [Boolean],
		},
		isWorkbenchedit: {
			type: [Boolean],
		},
		id: {
			type: [Number, String],
		},
	});

	const contentInfo = ref({
		titleExhibition: '',
		detailsContent: '',
		deployer: '',
		deployTime: '',
		noticeLevel: '',
	});

	const tableData = ref([]);

	function delEdit() {
		emit('deletePanelItemEvent', props.id);
	}

	// 点击更多跳往公告页面
	function goTOWork() {
		if (!props.isWorkbenchedit) {
			const url = `${import.meta.env.VITE_BASE_URL}announcement`;
			openWindow(url);
		}
	}

	// 查询工作台公告接口
	function getNoticeAll() {
		getnoticeall({
			parameters: [],
			sorts: defaultSort.value,
			requestPage: {
				pageNo: 1,
				limit: 10,
			},
		}).then((res) => {
			const noticeAll = res.data.rows.length > 5 ? res.data.rows.slice(0, 6) : res.data.rows;

			tableData.value = noticeAll;
		});
	}

	// 点击表格的一行
	function tableClick(row) {
		if (!props.isWorkbenchedit) {
			contentInfo.value = {
				titleExhibition: row.noticeTitle,
				detailsContent: row.noticeContent,
				deployer: row.deployer,
				deployTime: row.deployTime,
				noticeLevel: row.noticeLevel,
			};
			proxy.$refs['detailsRef'].show();
		}
	}

	getNoticeAll();
</script>

<style scoped lang="scss">
	// @import '@/assets/styles/base/base-variables.module.scss';

	.delEdit {
		position: absolute;
		top: 20px;
		right: 25px;
		// font-size: $app-fontsize-title;

		.el-icon {
			// color: $theme-workbench-icon-color;
			cursor: pointer;
		}
	}

	.noticeList {
		height: 100%;

		.title {
			font-weight: 600;
			font-size: 16px;
			color: #ffffff;
			line-height: 20px;
			text-align: left;

			.more {
				float: right;
				cursor: pointer;
				color: #5eebff;
			}
		}

		.list {
			height: calc(100% - 10px);
			padding: 10px;
			overflow: auto;

			.nodata {
				font-size: 16px;
				color: #ffffff;
				text-align: center;
			}

			.detail-info {
				font-size: 16px;
				color: #ffffff;
				line-height: 49px;

				.left,
				.right {
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					cursor: pointer;
				}

				.right {
					text-align: right;
				}

				.left {
					&::before {
						content: '';
						width: 6px;
						height: 6px;
						background: #5eebff;
						border-radius: 50%;
						margin-right: 5px;
						display: inline-block;
						vertical-align: middle;
						margin-top: -4px;
					}
				}
			}
		}
	}
</style>
